export const TOKEN_CREATE      = 'TOKEN_CREATE';
export const TOKEN_CREATE_DONE = 'TOKEN_CREATE_DONE';



// WEBPACK FOOTER //
// ./app/constants/tokenTypes.js